import React from 'react'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/client'
const Main = React.lazy(() => import('./Main'))

export const InstantPage = () => {
  const { loading, error, data } = useQuery(
    gql`
      query getMe {
        me {
          _id
          country {
            code
            markets(filter: "instant") {
              code
              name
              releaseDate
              mainCurrency {
                code
                name
                units
                format
                longFormat
              }
              secondaryCurrency {
                code
                name
                name
                units
                format
                longFormat
              }
            }
          }
          wallets {
            _id
            currency {
              code
              units
              format
              longFormat
              symbol
            }
            availableBalance
          }
        }
      }
    `,
    { fetchPolicy: 'cache-and-network' },
  )

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error! {error.message}</div>
  }

  const isChilean = data.me.country.code === 'CL'

  return (
    <>
      <Main
        markets={data.me.country.markets}
        assets={data.me.country.currencies}
        wallets={data.me.wallets}
        isChilean={isChilean}
      />
    </>
  )
}
